import * as React from 'react';
import { SVGProps } from 'react';

const IconCheckSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.606 8.794 1.46 5.93l-.674.74 3.916 3.564 6.12-7.293-.767-.643-5.45 6.496z"
    />
  </svg>
);
export default IconCheckSizeXs;
